import { en as meetingRoomsEn } from './meetingRooms/locales/en';
import { pt as meetingRoomsPT } from './meetingRooms/locales/pt';
import { en as buildingsEn } from './buildings/locales/en';
import { pt as buildingsPT } from './buildings/locales/pt';
import { en as visitsEn } from './visits/locales/en';
import { pt as visitsPT } from './visits/locales/pt';
import { en as visitorsEn } from './visitors/locales/en';
import { pt as visitorsPT } from './visitors/locales/pt';
import { en as consoleUsersEn } from './consoleUsers/locales/en';
import { pt as consoleUsersPT } from './consoleUsers/locales/pt';
import { en as parkingEn } from './parking/locales/en';
import { pt as parkingPT } from './parking/locales/pt';

export const en = {
    ...meetingRoomsEn,
    ...buildingsEn,
    ...visitsEn,
    ...visitorsEn,
    ...consoleUsersEn,
    ...parkingEn
};

export const pt = {
    ...meetingRoomsPT,
    ...buildingsPT,
    ...visitsPT,
    ...visitorsPT,
    ...consoleUsersPT,
    ...parkingPT
};